import * as React from "react";
import { Link } from "@abb/abb-common-ux-react";
import { ICellRendererParams } from "ag-grid-community";
import { useHistory } from "react-router";
import { memo } from "react";

export interface GridLinkRendererProps extends ICellRendererParams {
  text: string;
  link?: string | null;
  outsideLink?: boolean;
  icon?: string;
}

export const GridLinkRenderer = memo((props: GridLinkRendererProps) => {
  const history = useHistory();
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: props.icon ? "center" : "flex-start",
        alignItems: "center",
        height: "36px"
      }}
      className="ag-cell-value"
    >
      <Link
        target="_blank"
        discreet
        href={props.link ?? undefined}
        preventRedirect={props.outsideLink ? false : true}
        onClick={() => {
          if (props.link && !props.outsideLink) {
            history.push(props.link);
          }
        }}
        iconBefore={props.icon}
      >
        {props.text}
      </Link>
    </div>
  );
});
